<template>
  <div>
      <el-breadcrumb separator="/" style="margin-bottom: 20px;">
        <el-breadcrumb-item><a style="font-weight: 700; color: #333;">修改密码</a></el-breadcrumb-item>
      </el-breadcrumb>
    <el-card>
      <el-form :model="info" :rules="rules" ref="info" label-width="90px" class="demo-ruleForm" style="width: 400px; margin: 100px auto; ">
        <el-form-item label="旧密码:" prop="oldPwd">
          <el-input :type="oldPwd" v-model.trim="info.oldPwd" maxlength="16" placeholder="请输入旧密码">
            <i slot="suffix" class="cursor" :class="oldPwd == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(1, oldPwd)"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="newPwd">
          <el-input :type="newPwd" v-model.trim="info.newPwd" maxlength="16" placeholder="请输入新密码（8-16位数字大小写字母组合）">
            <i slot="suffix" class="cursor" :class="newPwd == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(2, newPwd)"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="newPwds">
          <el-input :type="newPwds" v-model.trim="info.newPwds" maxlength="16" placeholder="确认密码">
            <i slot="suffix" class="cursor" :class="newPwds == 'password'? 'iconfont icon-xianshi': 'iconfont icon-yincang'" @click="handleShow(3, newPwds)"></i>
          </el-input>
        </el-form-item>
        <div style="text-align: center;">
          <el-button type="primary" size="medium" style="margin-left: 40px;" :loading="info.loading" @click="handleSubmit">确 定</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { AdminUpdatePwd } from '@/api/system'
export default {
  data () {
    const checkPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码格式为8-16位数字大小写字母组合'))
        } else {
          callback()
        }
      }
    }
    const checkPPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        if (!reg.test(value)) {
          callback(new Error('密码格式为8-16位数字大小写字母组合'))
        } else {
          callback()
        }
      }
    }
    const checkPPwds = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.info.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      oldPwd: 'password',
      newPwd: 'password',
      newPwds: 'password',
      info: {
        loading: false,
        oldPwd: '',
        newPwd: '',
        newPwds: ''
      },
      rules: {
        oldPwd: [{ required: true, validator: checkPwd, trigger: 'blur' }],
        newPwd: [{ required: true, validator: checkPPwd, trigger: 'blur' }],
        newPwds: [{ required: true, validator: checkPPwds, trigger: 'blur' }]
      },
      msg: ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    handleReset () {
      this.$refs.info.resetFields()
    },
    handleSubmit () {
      this.$refs.info.validate((valid) => {
        if (!valid) return false
        this.info.loading = true
        const params = {
          password: md5(this.info.oldPwd),
          newPassword: md5(this.info.newPwd)
        }
        AdminUpdatePwd(params).then(res => {
          this.info.loading = false
          if (res.code == '000') {
            this.$message.success('修改成功')
            this.$refs.info.resetFields()
          }
        })
      })
    },
    handleShow(index, type) {
      switch (index) {
        case 1:
          if (type == 'password') {
            this.oldPwd = 'text'
          } else {
            this.oldPwd = 'password'
          }
          break
        case 2:
          if (type == 'password') {
            this.newPwd = 'text'
          } else {
            this.newPwd = 'password'
          }
          break
        case 3:
          if (type == 'password') {
            this.newPwds = 'text'
          } else {
            this.newPwds = 'password'
          }
          break
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
